export class UpdateResourceEvent {
  private _path: string;
  private _value: any;

  constructor(path: string, value: any) {
    this._path = path;
    this._value = value;
  }

  get path(): string {
    return this._path;
  }

  get value(): any {
    return this._value;
  }
}
